<div class="prestamo-bar">
  <img [src]="icono" alt="">
  <span>{{ texto }}</span>
</div>
